module.exports = __webpack_public_path__ + "static/media/ahmed.f1194e90.webp";